import { getRequest, postRequest } from '../request/request.service';
import {
  CompaniesResponse,
  CompanyMessageResponse,
  UpdateCompanyMessage,
} from './company-service.types';

export function getCompanyMessage(company_name: string) {
  return getRequest<CompanyMessageResponse>(
    `companies/company_messages?company_name=${company_name}`
  );
}

export function updateCompanyMessage(payload: UpdateCompanyMessage) {
  return postRequest(`companies/update_company_messages`, { data: payload });
}

export function getCompanies() {
  return getRequest<CompaniesResponse>(`companies`);
}
